export const convertBytesToHumanReadable = (bytes: number) => {
  if (bytes > 1000000) {
    return String(bytes / 1000000) + " mb";
  } else if (bytes > 1000) {
    return String(bytes / 1000) + " kb";
  } else {
    return String(bytes) + " b";
  }
};
